import { render, staticRenderFns } from "./LongTextEditor.vue?vue&type=template&id=370868a9&scoped=true&"
import script from "./LongTextEditor.vue?vue&type=script&lang=js&"
export * from "./LongTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./LongTextEditor.vue?vue&type=style&index=0&id=370868a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370868a9",
  null
  
)

component.options.__file = "LongTextEditor.vue"
export default component.exports